import { TextLargeParagraph } from '@carboncopyco/ui';
import { getTimezoneName } from '@carboncopyco/utils';
import { useState } from 'react';
import { DownloadCsvButton } from '../../../InfoPage/DownloadCsv';
import { TitleCard } from '../../../InfoPage/InfoPageCards/TitleCard';
import { useDashboardProps } from '../../DashboardContext';
import type { CsvParams } from '../../SessionBreakdownComponents/types';
import { ToursBreakdownTable } from './ToursBreakdownTable';

export const ToursSessionBreakdown = () => {
  const { organizationId } = useDashboardProps();
  const [csvParams, setCsvParams] = useState<CsvParams>({
    params: {
      organizationId,
      timezone: getTimezoneName(),
      resourceTypes: ['tour'],
    },
    isDisabled: false,
  });

  return (
    <TitleCard
      radius
      border="ds-regular"
      header={
        <div className="h-ds-15 flex px-6 items-center justify-between">
          <TextLargeParagraph
            label="Session breakdown"
            color="text-ds-natural-600"
          />
          <DownloadCsvButton
            params={csvParams.params}
            disabled={csvParams.isDisabled}
            location="analytics_page"
          />
        </div>
      }
    >
      <ToursBreakdownTable setCsvParams={setCsvParams} />
    </TitleCard>
  );
};
